<template>
    <!-- 机构开通申请 -->
    <div class="insRegistrationView">
        <div class="search_container">
            <el-form size="mini" ref="form" class="searchBox" :inline="true" :model="orgData">
                <el-form-item label="名称">
                    <el-input v-model="orgData.name" @change="getInsRegistrationView(1)" clearable placeholder="请输入机构名称"></el-input>
                </el-form-item>
                <el-form-item label="省份" class="mySelect">
                    <el-select v-model="orgData.provinceId" @change="getInsRegistrationView(1)" @clear="() => orgData.raceType = ''" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in provinceData" :key="item.id" :label="item.districtName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button size="mini" type="primary" @click="getInsRegistrationView(1)">查询</el-button>
        </div>
        <div class="comPractice_container">
            <basic-table v-loading="loading"  :isOperate="false" :isCheckbox='false' ref="insRegistrationViewTable" :tableHeader="insRegistrationViewHeader" :tableData="tableData" @operation="operation">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="data">
                    <!-- 
                        // 0 - 未提交 （当为未提交状态时，机构可进行编辑或提交操作)
                        // 1 - 待审批 (当为待审批状态时，机构可进行撤回操作，并且中心可进行 通过/驳回 的操作, 一旦中心操作后，则机构不可进行撤销操作)
                        // 2 - 已通过 (通过后可进行账户的维护)
                        // 3 - 已驳回 (驳回后,机构可进行编辑，并重新提交)
                     -->
                    <!-- <el-button size="mini" v-if="data.row.status == 3 || data.row.status == 0" @click="submitBtn('single', data.row)" type="text">提交</el-button>
                    <el-button size="mini" @click="editBtn(data.row)" type="text">编辑</el-button>
                    <el-button size="mini" v-if="data.row.status == 1" @click="withdrawBtn('single', data.row)" type="text">撤回</el-button>
                    <el-button size="mini" v-if="data.row.status == 2" @click="accountBtn(data.row)" type="text">账号</el-button>
                    <el-button size="mini" v-if="data.row.status == 3 || data.row.status == 0" @click="deleteApplyBtn(data.row)" type="text">删除</el-button> -->
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="pageSize" :page.sync="pageNum" @currentChange="currentChange"></pagination>
        </div>

    </div>
</template>

<script>
import { insRegistrationViewHeader } from './globalData'
// eslint-disable-next-line no-unused-vars
import fetch from '@/api/fetch'
export default {
    name: 'insRegistrationView',

    data() {
        return {
            insRegistrationViewHeader,
            loading: false,
            total: 15,
            pageSize: 15,
            pageNum: 1,
            tableData: [],
            provinceData:[],
            orgData: {
                name: '',
                provinceId: '',
                cityId: '',
                enterStatus: ''
            }
        };
    },

    mounted() {
        this.getProvinceList()
        this.getInsRegistrationView()
    },


    methods: {
        currentChange(val) {
            this.pageSize = val.limit
            this.pageNum = val.page
            this.getInsRegistrationView(this.pageNum)
        },
        operation() {},
        getInsRegistrationView(pageNum) {
            let sysTypeTextList = {
                1: '连锁国赛',
                2: '中东欧',
                3: '金砖智能财税',
                4: '金砖金融科技',
                5: '审计'
            }
            fetch.getApplyInterlist({
                ...this.orgData, pageNum: pageNum || this.pageNum, pageSize: this.pageSize
            }).then(res => {
                if(res.code == '0') {
                    console.log(res)
                    this.tableData = res.data.list.map(item => {
                        return {...item, comTypeText: item.comType == 1 ? "院校" : "企业", sysTypeText: sysTypeTextList[item.sysType]}
                    })
                }else {
                    this.$message.error(res.msg)
                }
            })
        },
        getProvinceList() { // 省份下拉
            fetch.getProvinceList2().then(res => {
                if (res.code == '0') {
                    this.provinceData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        
    },
    components: {
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue'),
    }
};
</script>

<style lang="scss" scoped>
.insRegistrationView {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
        .btnBox {
            width: 55%;
            text-align: right;
        }
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .addPlanDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .formcenter {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }
        /deep/.el-checkbox {
            display: flex;
            align-items: center;
        }
        // .formLeft {
        //     padding-left: 17px;
        //     box-sizing: border-box;
        // }
        .mechanism {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
        }
        .mechanism_center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .arrow_left {
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #fff;
                margin-bottom: 5px;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
            .arrow_right {
                width: 30px;
                height: 30px;
                color: #fff;
                margin-top: 5px;
                line-height: 30px;
                text-align: center;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
        }
        .mechanism_left {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanism_right {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanismToptitle {
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #ccc;
            .left_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .right_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
        }
        .mechanismBottomMin {
            width: 100%;
            height: calc(100% - 50px);
        }
        .mechanismSearch {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .mechanismTable {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .mechanismTable2 {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .planInfo {
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            align-content: space-around;
            color: #409eff;
            .planInfo_top {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .left {
                    margin-right: 30px;
                }
            }
        }
        .mechanismOrgName {
            display: inline-block;
            width: 180px;
            height: 33px;
            line-height: 33px;
            overflow-x: hidden;
            overflow-y: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText {
            display: inline-block;
            width: 62px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText2 {
            display: inline-block;
            width: 50px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
    }
    .editDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-left: 150px;
            padding-bottom: 0px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .editCenterTwoBox {
            display: flex;
            justify-content: flex-start;
        }
    }
    .accountDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .reason {
            margin-bottom: 10px;
            color: #409eff;
        }
    }
    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>